/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ApplicationState from 'store/application'
import GUI              from 'services/gui';

const __vue_script__ = {

  /** @since 3.8.6 */
  name: 'print-page',

  data() {
    const state = this.$options.service.state || {};
    return {
      state,
      // extract `state.format` so it doesn't react to Print.vue changes
      format: state.format,
      ready : false,
    }
  },

  methods: {

    async downloadImage() {
      try {
        GUI.disableSideBar(true);
        this.state.downloading = true;
        if (['jpg', 'png', 'svg'].includes(this.format)) {
          await this.imageToDataURL({ src: this.state.url, type: `image/${this.format}` });
          setTimeout(() => {
            GUI.disableSideBar(false);
            this.state.downloading = false;
          });
        }
      } catch (e) {
        console.warn(e);
      }
    },

    imageToDataURL({
      src,
      type     = 'image/jpeg',
      callback = () => {},
    }) {
      return new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = function() {
          const canvas  = document.createElement('canvas');
          const context = canvas.getContext('2d');
          canvas.height = this.naturalHeight;
          canvas.width  = this.naturalWidth;
          context.drawImage(this, 0, 0);
          const dataURL = canvas.toDataURL(type);
          callback(dataURL);
          resolve(dataURL);
        };
        image.onerror = reject;
        image.src = src;
      });
    },

  },
  /**
   * @since v3.11.0 To show to user loading bar
   */
  watch: {
    ready: {
      handler(bool) {
        GUI.setLoadingContent(!bool);
      },
      immediate: true,
    }
  },

  beforeDestroy() {
    if (this.state.url && 'POST' === ApplicationState.project.state.ows_method) {
      URL.revokeObjectURL(this.state.url);
    }
  },

};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"print-output"}},[_c('transition',{attrs:{"duration":500,"name":"fade"}},[_c('bar-loader',{attrs:{"loading":_vm.state.loading && _vm.state.layers}})],1),_vm._v(" "),(_vm.state.layers)?[(['pdf', 'geopdf'].includes(_vm.format))?_c('iframe',{ref:"out",attrs:{"src":_vm.state.url},on:{"load":function($event){_vm.ready = true},"error":function($event){_vm.ready = true}}}):_c('div',{staticClass:"g3w-print-image-output"},[_c('div',{attrs:{"id":"g3w-print-header"}},[_c('div',{class:{ 'g3w-disabled': !!(_vm.state.downloading && _vm.state.layers) }},[_c('a',{attrs:{"href":_vm.state.url,"download":("download." + _vm.format)}},[_c('button',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip",value:('Download Image'),expression:"'Download Image'"}],staticClass:"btn skin-button",class:_vm.$fa('download'),attrs:{"data-placement":"left","role":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.downloadImage.apply(null, arguments)}}})])])]),_vm._v(" "),(_vm.state.url)?_c('div',{staticClass:"g3w-print-url"},[_c('img',{ref:"out",attrs:{"src":_vm.state.url},on:{"load":function($event){_vm.ready = true},"error":function($event){_vm.ready = true}}})]):_vm._e()])]:_c('h4',{directives:[{name:"t",rawName:"v-t",value:('No Layer to print'),expression:"'No Layer to print'"}]})],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-551265b6_0", { source: "#print-output[data-v-551265b6]{height:100%;position:relative}#print-output>iframe[data-v-551265b6]{border:0;width:100%;height:100%}.g3w-print-image-output[data-v-551265b6]{display:flex;flex-direction:column;position:relative;height:100%}#g3w-print-header[data-v-551265b6]{display:flex;justify-content:flex-end;align-items:flex-end;margin-top:5px;margin-bottom:5px}#g3w-print-header button[data-v-551265b6]{font-weight:700}.g3w-print-url[data-v-551265b6]{height:100%;width:100%;position:relative;overflow-y:auto}.g3w-print-url>img[data-v-551265b6]{height:auto;max-width:100%}#print-output>h4[data-v-551265b6]{font-weight:700}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-551265b6"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "PrintPage.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__